<Bi-Sidebar [items]="menuItemsService.items" [excludedFromSearchIndexes]="excludedFromSearchIndexes"></Bi-Sidebar>